import { updatePropertyIcons } from '../layers';
import Property from '../models/property';
import { hasUserContactedProperty, hasUserSavedProperty } from '../storage';

const onSavedListUpdate = ( ctx, event ) => {
    ctx.properties.forEach( ( property: Property ) => {
        property.saved = hasUserSavedProperty( property.id );
        property.contacted = hasUserContactedProperty( property.id );
    } );

    updatePropertyIcons( ctx );
};

export default onSavedListUpdate;
